import type React from 'react';
import {cn} from '../../../../../../lib/classname';
import {CommonLink} from '../../../../../../shared/components/CommonLink';
import {PROFILE_LIST} from './constants';
import type {UnfilledField} from './types';

export type ProfileDetailListProps = {
  unfilledFields: UnfilledField[];
};

export const ProfileDetailList: React.FC<ProfileDetailListProps> = ({
  unfilledFields,
}) => {
  return (
    <div className="bg-white p-16 rounded-16">
      <div className="grid grid-cols-3 gap-x-16 gap-y-8">
        {PROFILE_LIST.map((item) => {
          const isUnfilled = unfilledFields.some(
            (field) => field.profileEditPageLink === item.link,
          );

          return (
            <div key={item.label} className="flex items-center justify-between">
              <div className="font-medium text-center">{item.label}</div>
              <CommonLink
                href={item.link}
                className={cn(
                  'w-[64px] font-bold text-sm py-8 border-2 text-center rounded-full hover:opacity-60',
                  {
                    'text-notification border-notification': isUnfilled,
                    'text-primary border-primary': !isUnfilled,
                  },
                )}
              >
                {isUnfilled ? '未入力' : '編集'}
              </CommonLink>
            </div>
          );
        })}
      </div>
    </div>
  );
};
